export default [
  {
    path: '/new-services',
    name: 'new-services-external',
    component: () => import('@/views/services/NewServicesExternal.vue'),
    meta: { auth: false }
  }
]
